import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Row from '@common/Row';
import Img from '@common/Image';

const UsersLeadershipCards = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        {list &&
          <Row className='row-cols-2 row-cols-lg-4 gx-lg-5 g-3'>
            {list.map((user, index) => (
              <div key={index} className='d-flex flex-column'>
                {user.image &&
                  <div className='overflow-hidden rounded'>
                    <Img 
                      image={user.image.gatsbyImageData}
                      file={user.image.file}
                      style={{width: '100%', aspectRatio: '5 / 6'}}
                    />
                  </div>
                }
                <p className='mt-1 fs-24 fw-semibold'>{user.name}</p>
                <p>{user.title}</p>
              </div>
            ))}
          </Row>
        }
      </Container>
    </Section>
  )
}

export default UsersLeadershipCards
